import { render, staticRenderFns } from "./taxStartingDateStep.vue?vue&type=template&id=b7ae143c&"
import script from "./taxStartingDateStep.vue?vue&type=script&lang=js&"
export * from "./taxStartingDateStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports